// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;600;800&display=swap'); */

:root {
  /* YOUR REQUESTED COLORS */
  --primary: #1a5f3f;
  --primary-dark: #144d32;
  --primary-light: #2d8659;
  --text-main: #1f2937;
  --text-muted: #6b7280;
  --white: #ffffff;
  --bg-page: #f3f4f6;
}

.People_peopleContainer__TC9w7 {
  min-height: 100vh;
  background-color: var(--bg-page);
  font-family: 'Vazirmatn', sans-serif;
  padding: 40px 20px;
  direction: rtl;
}

/* HEADER SECTION */
.People_headerSection__a35aF {
  text-align: center;
  margin-bottom: 50px;
}

.People_pageTitle__i9C3X {
  font-size: 36px;
  font-weight: 800;
  color: var(--primary);
  margin-bottom: 10px;
}

.People_pageSubtitle__8fnbD {
  color: var(--text-muted);
  font-size: 16px;
  margin-bottom: 30px;
}

/* CONTROLS */
.People_controlBar__6qInx {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
}

.People_searchBox__c3us1 {
  background: var(--white);
  padding: 10px 20px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  gap: 10px;
  box-shadow: 0 4px 15px rgba(26, 95, 63, 0.08);
  width: 250px;
}

.People_searchBox__c3us1 i { color: var(--primary-light); }
.People_searchBox__c3us1 input {
  border: none;
  outline: none;
  font-family: inherit;
  width: 100%;
}

.People_filterGroup__RxmM7 {
  display: flex;
  background: #e5e7eb;
  padding: 4px;
  border-radius: 50px;
}

.People_filterBtn__IuI-R {
  background: transparent;
  border: none;
  padding: 8px 20px;
  border-radius: 40px;
  cursor: pointer;
  color: var(--text-muted);
  font-family: inherit;
  font-weight: 600;
  transition: 0.3s;
}

.People_filterBtn__IuI-R.People_active__fjfHD {
  background: var(--white);
  color: var(--primary);
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* GRID LAYOUT */
.People_gridContainer__nmJPH {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

/* CARD DESIGN - MATCHING THE IMAGE STYLE */
.People_card__Nu1Ik {
  background: var(--white);
  border-radius: 32px; /* Very rounded corners like image */
  overflow: hidden;
  box-shadow: 0 20px 40px -10px rgba(26, 95, 63, 0.15);
  transition: transform 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 480px; /* Taller format like a portrait card */
}

.People_card__Nu1Ik:hover {
  transform: translateY(-8px);
  box-shadow: 0 25px 50px -12px rgba(26, 95, 63, 0.25);
}

/* TOP VISUAL AREA (Replaces the Photo) */
.People_cardVisual__kmPhu {
  height: 55%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Pattern overlay for texture */
  background-image: radial-gradient(circle at 10% 10%, rgba(255,255,255,0.1) 0%, transparent 20%);
}

.People_bigIcon__Gzzco {
  font-size: 100px;
  color: rgba(255, 255, 255, 0.2);
  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.2));
  transform: scale(1);
  transition: transform 0.5s ease;
}

.People_card__Nu1Ik:hover .People_bigIcon__Gzzco {
  transform: scale(1.1) rotate(-5deg);
  color: rgba(255, 255, 255, 0.3);
}

/* GLASS BADGE - Floating pill like in image */
.People_glassBadge__dtvsg {
  position: absolute;
  bottom: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2); /* Glass effect */
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 85%;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.People_badgeDot__b27yk {
  width: 6px;
  height: 6px;
  background: #4ade80;
  border-radius: 50%;
  box-shadow: 0 0 5px #4ade80;
}

/* CONTENT BODY */
.People_cardContent__V04pr {
  padding: 24px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.People_nameRow__hDIBv {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
}

.People_personName__ICJZL {
  font-size: 20px;
  font-weight: 800;
  color: var(--primary);
  line-height: 1.3;
  margin: 0;
}

.People_actionBtn__4wtw4 {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #e5e7eb;
  background: transparent;
  color: var(--primary);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  flex-shrink: 0;
}

.People_actionBtn__4wtw4:hover {
  background: var(--primary);
  color: white;
  border-color: var(--primary);
}

.People_personBio__I2YW3 {
  font-size: 14px;
  color: var(--text-muted);
  line-height: 1.6;
  margin-bottom: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* FOOTER */
.People_footerRow__xiK8g {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #f3f4f6;
  padding-top: 15px;
}

.People_skillStack__w-vhq {
  display: flex;
  gap: 5px;
}

.People_miniTag__Ap55s {
  font-size: 11px;
  background: #f0fdf4;
  color: var(--primary-light);
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 600;
}

.People_socialLinks__Zp2XJ {
  display: flex;
  gap: 12px;
}

.People_socialLinks__Zp2XJ a {
  color: #9ca3af;
  font-size: 16px;
  transition: 0.2s;
}

.People_socialLinks__Zp2XJ a:hover {
  color: var(--primary);
  transform: translateY(-2px);
}

/* RESPONSIVE */
@media (max-width: 768px) {
  .People_gridContainer__nmJPH {
    grid-template-columns: 1fr;
    padding: 0 20px;
  }
  .People_card__Nu1Ik {
    height: auto;
    min-height: 450px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/People/People.module.css"],"names":[],"mappings":"AAAA,yGAAyG;;AAEzG;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,6CAA6C;EAC7C,YAAY;AACd;;AAEA,6BAAe,2BAA2B,EAAE;AAC5C;EACE,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;EACxB,mBAAmB,EAAE,oCAAoC;EACzD,gBAAgB;EAChB,oDAAoD;EACpD,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,aAAa,EAAE,uCAAuC;AACxD;;AAEA;EACE,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,+FAA+F;AACjG;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,+CAA+C;EAC/C,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,oCAAoC,EAAE,iBAAiB;EACvD,2BAA2B;EAC3B,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;IAC1B,eAAe;EACjB;EACA;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF","sourcesContent":["/* @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;600;800&display=swap'); */\n\n:root {\n  /* YOUR REQUESTED COLORS */\n  --primary: #1a5f3f;\n  --primary-dark: #144d32;\n  --primary-light: #2d8659;\n  --text-main: #1f2937;\n  --text-muted: #6b7280;\n  --white: #ffffff;\n  --bg-page: #f3f4f6;\n}\n\n.peopleContainer {\n  min-height: 100vh;\n  background-color: var(--bg-page);\n  font-family: 'Vazirmatn', sans-serif;\n  padding: 40px 20px;\n  direction: rtl;\n}\n\n/* HEADER SECTION */\n.headerSection {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.pageTitle {\n  font-size: 36px;\n  font-weight: 800;\n  color: var(--primary);\n  margin-bottom: 10px;\n}\n\n.pageSubtitle {\n  color: var(--text-muted);\n  font-size: 16px;\n  margin-bottom: 30px;\n}\n\n/* CONTROLS */\n.controlBar {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 15px;\n  flex-wrap: wrap;\n}\n\n.searchBox {\n  background: var(--white);\n  padding: 10px 20px;\n  border-radius: 50px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 4px 15px rgba(26, 95, 63, 0.08);\n  width: 250px;\n}\n\n.searchBox i { color: var(--primary-light); }\n.searchBox input {\n  border: none;\n  outline: none;\n  font-family: inherit;\n  width: 100%;\n}\n\n.filterGroup {\n  display: flex;\n  background: #e5e7eb;\n  padding: 4px;\n  border-radius: 50px;\n}\n\n.filterBtn {\n  background: transparent;\n  border: none;\n  padding: 8px 20px;\n  border-radius: 40px;\n  cursor: pointer;\n  color: var(--text-muted);\n  font-family: inherit;\n  font-weight: 600;\n  transition: 0.3s;\n}\n\n.filterBtn.active {\n  background: var(--white);\n  color: var(--primary);\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n}\n\n/* GRID LAYOUT */\n.gridContainer {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* CARD DESIGN - MATCHING THE IMAGE STYLE */\n.card {\n  background: var(--white);\n  border-radius: 32px; /* Very rounded corners like image */\n  overflow: hidden;\n  box-shadow: 0 20px 40px -10px rgba(26, 95, 63, 0.15);\n  transition: transform 0.3s ease;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 480px; /* Taller format like a portrait card */\n}\n\n.card:hover {\n  transform: translateY(-8px);\n  box-shadow: 0 25px 50px -12px rgba(26, 95, 63, 0.25);\n}\n\n/* TOP VISUAL AREA (Replaces the Photo) */\n.cardVisual {\n  height: 55%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* Pattern overlay for texture */\n  background-image: radial-gradient(circle at 10% 10%, rgba(255,255,255,0.1) 0%, transparent 20%);\n}\n\n.bigIcon {\n  font-size: 100px;\n  color: rgba(255, 255, 255, 0.2);\n  filter: drop-shadow(0 4px 10px rgba(0,0,0,0.2));\n  transform: scale(1);\n  transition: transform 0.5s ease;\n}\n\n.card:hover .bigIcon {\n  transform: scale(1.1) rotate(-5deg);\n  color: rgba(255, 255, 255, 0.3);\n}\n\n/* GLASS BADGE - Floating pill like in image */\n.glassBadge {\n  position: absolute;\n  bottom: 20px;\n  right: 20px;\n  background: rgba(255, 255, 255, 0.2); /* Glass effect */\n  backdrop-filter: blur(12px);\n  -webkit-backdrop-filter: blur(12px);\n  padding: 8px 16px;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  font-size: 13px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 85%;\n  box-shadow: 0 4px 15px rgba(0,0,0,0.1);\n}\n\n.badgeDot {\n  width: 6px;\n  height: 6px;\n  background: #4ade80;\n  border-radius: 50%;\n  box-shadow: 0 0 5px #4ade80;\n}\n\n/* CONTENT BODY */\n.cardContent {\n  padding: 24px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.nameRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 12px;\n}\n\n.personName {\n  font-size: 20px;\n  font-weight: 800;\n  color: var(--primary);\n  line-height: 1.3;\n  margin: 0;\n}\n\n.actionBtn {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 1px solid #e5e7eb;\n  background: transparent;\n  color: var(--primary);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: 0.2s;\n  flex-shrink: 0;\n}\n\n.actionBtn:hover {\n  background: var(--primary);\n  color: white;\n  border-color: var(--primary);\n}\n\n.personBio {\n  font-size: 14px;\n  color: var(--text-muted);\n  line-height: 1.6;\n  margin-bottom: 20px;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* FOOTER */\n.footerRow {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-top: 1px solid #f3f4f6;\n  padding-top: 15px;\n}\n\n.skillStack {\n  display: flex;\n  gap: 5px;\n}\n\n.miniTag {\n  font-size: 11px;\n  background: #f0fdf4;\n  color: var(--primary-light);\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n.socialLinks {\n  display: flex;\n  gap: 12px;\n}\n\n.socialLinks a {\n  color: #9ca3af;\n  font-size: 16px;\n  transition: 0.2s;\n}\n\n.socialLinks a:hover {\n  color: var(--primary);\n  transform: translateY(-2px);\n}\n\n/* RESPONSIVE */\n@media (max-width: 768px) {\n  .gridContainer {\n    grid-template-columns: 1fr;\n    padding: 0 20px;\n  }\n  .card {\n    height: auto;\n    min-height: 450px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"peopleContainer": `People_peopleContainer__TC9w7`,
	"headerSection": `People_headerSection__a35aF`,
	"pageTitle": `People_pageTitle__i9C3X`,
	"pageSubtitle": `People_pageSubtitle__8fnbD`,
	"controlBar": `People_controlBar__6qInx`,
	"searchBox": `People_searchBox__c3us1`,
	"filterGroup": `People_filterGroup__RxmM7`,
	"filterBtn": `People_filterBtn__IuI-R`,
	"active": `People_active__fjfHD`,
	"gridContainer": `People_gridContainer__nmJPH`,
	"card": `People_card__Nu1Ik`,
	"cardVisual": `People_cardVisual__kmPhu`,
	"bigIcon": `People_bigIcon__Gzzco`,
	"glassBadge": `People_glassBadge__dtvsg`,
	"badgeDot": `People_badgeDot__b27yk`,
	"cardContent": `People_cardContent__V04pr`,
	"nameRow": `People_nameRow__hDIBv`,
	"personName": `People_personName__ICJZL`,
	"actionBtn": `People_actionBtn__4wtw4`,
	"personBio": `People_personBio__I2YW3`,
	"footerRow": `People_footerRow__xiK8g`,
	"skillStack": `People_skillStack__w-vhq`,
	"miniTag": `People_miniTag__Ap55s`,
	"socialLinks": `People_socialLinks__Zp2XJ`
};
export default ___CSS_LOADER_EXPORT___;
